<quick-preview-panel
  *ngIf="form"
  [heading]="isNew ? (cloningFromSource? 'Register Session from Source':'Register Session') : 'Edit Session'"
  [color]="form.valid ? 'primary' : 'warn'"
>
  <div class="p-3 pt-4" [formGroup]="form" *ngIf="(isNew || existing)">
    <div class="row p-0 m-0">
      <input type="hidden" formControlName="id">
      <div
        [ngClass]="'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 m-0 p-0 pe-2 mb-2'"
      >
        <mat-form-field class="d-block">
          <mat-label>Name</mat-label>
          <input type="text" matInput class="d-block"
                 formControlName="name">
          <mat-error *ngIf="form.get('name')!.hasError('required')">
            Required field
          </mat-error>
          <mat-error *ngIf="form.get('name')!.hasError('exists')">
            Already exists
          </mat-error>
        </mat-form-field>
      </div>
      <div
        [ngClass]="'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 m-0 p-0 pe-2 mb-2'"
      >
        <mat-form-field class="d-block">
          <mat-label>Description</mat-label>
          <input type="text" matInput class="d-block"
                 formControlName="description">
        </mat-form-field>
      </div>
    </div>
    <div class="row p-0 m-0">
      <div
        [ngClass]="'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 m-0 p-0 pe-2 mb-2'"
      >
        <mat-form-field class="d-block">
          <mat-label>Assistant</mat-label>
          <mat-select formControlName="chatbot">
            <mat-option
              *ngFor="let c of chatbots"
              [value]="c.id">{{c.id}} - {{c.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div
        [ngClass]="'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 m-0 p-0 pe-2 mb-2'"
      >
        <mat-form-field class="d-block">
          <mat-label>Template</mat-label>
          <mat-select formControlName="templateId">
            <mat-option *ngFor="let t of filterTemplatesForAssistant()" [value]="t.id">{{t.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <actions-container>
      <back-button></back-button>
      <button
        [disabled]="!form.valid"
        color="primary"
        class="mx-2"
        mat-raised-button
        (click)="save()"
      >
        <mat-icon class="valign-middle">save</mat-icon>
        Save
      </button>

    </actions-container>
  </div>

</quick-preview-panel>
<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<error-panel ngClass="my-4" [error]="error"></error-panel>

